import moment from 'moment-timezone';

import {
  CUTOFF_DATE_FORMAT,
  CUTOFF_TIME_FORMAT,
  SHORT_DAY_LONG_MONTH_DELIVERY_DATE_FORMAT,
  SHORT_DELIVERY_DATE_FORMAT,
  THANK_YOU_CUTOFF_DATE_FORMAT,
  WEEK_OF_DELIVERY_DATE_FORMAT,
} from 'lib/constants';

export const basketCutoffDate = editingCutoff => {
  return moment(editingCutoff).format(CUTOFF_DATE_FORMAT);
};

export const basketCutoffDateShort = editingCutoff => {
  return moment(editingCutoff).format(SHORT_DELIVERY_DATE_FORMAT);
};

export const thankYouBasketCutoffDate = editingCutoff => {
  return moment(editingCutoff).format(THANK_YOU_CUTOFF_DATE_FORMAT);
};

export const basketCutoffTime = editingCutoff => {
  return `${moment.parseZone(editingCutoff).format(CUTOFF_TIME_FORMAT)} ${
    moment(editingCutoff).isDST() ? 'CDT' : 'CST'
  }`;
};

export const basketCutoffTimeShort = editingCutoff => {
  const format = moment.parseZone(editingCutoff).format('mm') === '00' ? 'hA' : CUTOFF_TIME_FORMAT;
  return `${moment.parseZone(editingCutoff).format(format)} ${
    moment(editingCutoff).isDST() ? 'CDT' : 'CST'
  }`;
};

export const basketCutoffLocalTime = editingCutoff => {
  const localTime = moment(editingCutoff).local();

  return `${localTime.format(CUTOFF_TIME_FORMAT)} (${localTime.tz(moment.tz.guess()).format('z')})`;
};

export const basketCutoffLocalTimeNoZone = editingCutoff => {
  const localTime = moment(editingCutoff).local();

  return localTime.format(CUTOFF_TIME_FORMAT);
};

export const basketDeliveryDate = deliverDate =>
  moment(deliverDate).format(SHORT_DAY_LONG_MONTH_DELIVERY_DATE_FORMAT);

export const basketShortMonthDeliveryDate = deliveryDate =>
  moment(deliveryDate).format(SHORT_DELIVERY_DATE_FORMAT);

export const basketWeekOfDeliveryDate = deliveryDate =>
  moment(deliveryDate).format(WEEK_OF_DELIVERY_DATE_FORMAT);
export const editingCutoffDisplay = editingCutoff =>
  `${basketCutoffLocalTime(editingCutoff)} on ${basketCutoffDateShort(editingCutoff)}`;
